import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import DropDownListItem from "./DropDownListItem";
import { css } from "@emotion/react";

const DropDownList = forwardRef(function DropDownList(props: any, ref) {
  const { items, onUpdateSelectedItemHandler } = props;

  const [showDropdownList, setShowDropdownList] = useState(false);
  const [_selectedItem, _setSelectedItem] = useState(null);
  const [_dropDownTitle, _setDropDownTitle] = useState(null);
  const [_dropDownPosition, _setDropDownPosition] = useState(null);

  const dropDownListRef = useRef(null);

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (dropDownListRef.current && dropDownListRef.current.contains(event.target)) {
        return;
      }

      _closeDropDownList();
    };

    document.addEventListener("mousedown", handlePointerDown);

    return () => document.removeEventListener("mousedown", handlePointerDown);
  }, [showDropdownList]);

  const _openDropDownList = ({ title, selectedItem, position }) => {
    if (window.innerHeight < position.dropDownPositionWrtVpt[0]+615) {
      position.top = position.top - ((position.dropDownPositionWrtVpt[0]+615) - window.innerHeight) - 80
    }

    if (window.innerWidth < position.dropDownPositionWrtVpt[1]+400) {
      position.left = position.left - ((position.dropDownPositionWrtVpt[1]+400) - window.innerWidth) - 80
    }

    _setDropDownPosition(position);
    _setSelectedItem(selectedItem);
    _setDropDownTitle(title);
    setShowDropdownList(true);
  }

  const _closeDropDownList = () => {
    setShowDropdownList(false);
    _setSelectedItem(null);
    _setDropDownTitle(null);
    _setDropDownPosition(null);
  }

  const onItemSelectHandler = (item) => {
    _setSelectedItem(item);
    onUpdateSelectedItemHandler(item);
    _closeDropDownList();
  };

  useImperativeHandle(ref, () => ({
    open: _openDropDownList,
    close: _closeDropDownList,
    selectedItem: _selectedItem
  }));

  


  return (
    <>
      {showDropdownList && (
        <div
          ref={dropDownListRef}
          css={styles.dropDownListContainer}
          style={{ top: _dropDownPosition.top, left: _dropDownPosition.left }}
          onClick={e=>{e.stopPropagation()}}
        >
          <div css={styles.dropDownListHeader}>
            <span css={styles.title}>{_dropDownTitle}</span>
            <div css={styles.closeIcon} onClick={_closeDropDownList}>
              &#x2715;
            </div>
          </div>
          <div css={styles.dropDownContainer}>
            {items.map(item => (
              <DropDownListItem
                key={item?.id}
                item={item}
                _isItemSelected={_selectedItem?.id === item?.id}
                onItemSelectHandler={onItemSelectHandler}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
});

export default DropDownList;

const styles = {
  dropDownListContainer: css`
    position: absolute;
    background: #FFFFFF;
    width: 400px;
    z-index: 10;
    box-shadow: 0px 1px 24px 8px #26262629;
    border: 1px solid #DEDEDE;
    border-radius: 8px;
    overflow: hidden;
    cursor: default;
    height: 615px;
  `,
  dropDownListHeader: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 1px 4px 0px #2626260D;
    background: #FFFFFF;
    padding: 15px;
    color: #262626;
  `,
  title: css`
    color: #262626;
    font-size: 14px;
    font-weight: 400;
    line-height: 23.8px;
    letter-spacing: 0.02em;
  `,
  closeIcon: css`
    cursor: pointer;
    font-size: 15px;
  `,
  dropDownContainer: css`
    height: 560px;
    overflow-y: scroll;
    padding: 15px;
    display: flex;
    gap: 10px;
    flex-direction: column;
    transition: all .3s;
    ::-webkit-scrollbar {
      display: block !important;
      width: 9px;
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    ::-webkit-scrollbar-thumb {
      background: #B9B9B9;
      border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: rgb(158, 158, 158);
    }
  `
};
